import translate from '@/utils/translate';
import type {DisplayItem} from '@/views/creators/creator-crm/components/active-filters-bar/displayItemTypes';
import {getActiveFilterKey} from '@/views/creators/creator-crm/components/active-filters-bar/useActiveFiltersBar';

export function getItemKey(item: DisplayItem): string {
  if (item.type === 'searchChip') {
    return `${item.searchType}-${item.value}`;
  }
  return getActiveFilterKey(item.data);
}

export function getChipLabel(item: DisplayItem): string {
  if (item.type === 'searchChip') {
    return item.value;
  }

  const {groupId, filterId, platformFilterId, filterMetadata} = item.data;
  const {filterName, filterType, value} = filterMetadata;
  const isRange = filterType === 'rangeSelection';

  // Platform metrics (e.g., Followers, Eng Rate) live under groupId 'platforms'
  // but are NOT audience filters. Check them first so they get a clean
  // "<metric>: <value>" label instead of being prefixed with "Audience".
  if (filterId === 'platformMetrics' && platformFilterId) {
    return `${filterName}: ${value}`;
  }

  // Audience filters: groupId is 'platforms' but not the platform selector
  // itself and not platform metrics (handled above).
  if (groupId === 'platforms' && filterId !== 'platform') {
    if (isRange) {
      return `${translate('Audience')} ${filterName}: ${value}`;
    }
    return `${translate('Audience')}: ${value}`;
  }

  // Creator range filters (e.g., Age: 22–55)
  if (isRange) {
    return `${filterName}: ${value}`;
  }

  // Everything else: self-describing
  return value;
}
